import { render, staticRenderFns } from "./AuthenticationPopup.vue?vue&type=template&id=87c304d0&scoped=true"
import script from "./AuthenticationPopup.vue?vue&type=script&lang=js"
export * from "./AuthenticationPopup.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationPopup.vue?vue&type=style&index=0&id=87c304d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c304d0",
  null
  
)

export default component.exports